
import React from 'react';

import FSIndex from "@dndComponents/FSIndex";

export default function BackgroundIndex() {
  return (
    <FSIndex
      data_type="background"
      quick_fields={["feat","ability_scores","tags"]}
      // save_all
    />
  );
}
